import styled from 'styled-components';

export const StyledTable = styled.table(
  ({
    theme: {
      responsive: { mobile },
    },
  }) => ({
    [mobile]: {
      display: 'block',
    },
    width: '100%',
  }),
);

export const StyledTbody = styled.tbody(
  ({
    theme: {
      responsive: { mobile },
    },
  }) => ({
    [mobile]: {
      display: 'block',
    },
    width: '100%',
  }),
);

export const StyledTd = styled.td(
  ({
    width,
    theme: {
      spacing,
      colors,
      font,
      responsive: { mobile },
    },
  }) => ({
    '&:first-child': {
      paddingLeft: spacing.lg,
    },
    '&:last-child': {
      paddingRight: spacing.lg,
    },
    color: colors.black,
    fontSize: font.size.sm,
    lineHeight: font.lineHeight.sm,
    maxWidth: 0,
    [mobile]: {
      '&:first-child': {
        paddingLeft: spacing.md,
      },
      '&:last-child': {
        paddingRight: spacing.md,
      },
      color: colors.darkGrey,
      display: 'block',
      maxWidth: '100%',
      padding: `${spacing.sm} ${spacing.md} 0 ${spacing.md}`,
      width: '100%',
    },
    padding: spacing.md,
    textAlign: 'left',
    verticalAlign: 'middle',
    width: width || 'auto',
  }),
);

export const StyledTh = styled.th(({ theme: { font, spacing, colors } }) => ({
  '&:first-child': {
    paddingLeft: spacing.lg,
  },
  '&:last-child': {
    paddingRight: spacing.lg,
  },
  color: colors.lavender,
  fontSize: font.size.sm,
  padding: `${spacing.xs} ${spacing.md}`,
  textAlign: 'left',
}));

export const StyledThead = styled.thead(
  ({
    theme: {
      responsive: { mobile },
    },
  }) => ({
    [mobile]: {
      display: 'block',
    },
    width: '100%',
  }),
);

export const StyledTheadTr = styled.tr(
  ({
    theme: {
      colors,
      responsive: { mobile },
    },
  }) => ({
    borderBottom: `1px solid ${colors.lightGrey}`,
    borderTop: `1px solid ${colors.lightGrey}`,

    [mobile]: {
      display: 'block',
      th: {
        '&:first-child': {
          display: 'block',
          width: '100%',
        },
        display: 'none',
      },
      width: '100%',
    },
  }),
);

export const StyledTr = styled.tr(
  ({
    theme: {
      spacing,
      colors,
      responsive: { mobile },
    },
  }) => ({
    '&:hover': {
      td: {
        backgroundColor: colors.backgroundGreyHighlight,
      },
    },
    borderBottom: `1px solid ${colors.lightGrey}`,
    [mobile]: {
      '&:hover': {
        td: {
          backgroundColor: colors.white,
        },
      },
      display: 'block',
      padding: `${spacing.sm} 0`,
      width: '100%',
    },
    position: 'relative',
  }),
);
